import { KycCardLayout } from '../KycCard/KycCardLayout';
import ClockIcon from '@ping/assets/Icon/clock.svg';
import { t } from '@ping/helpers';
import { KycCardContactUsSection } from '../KycCardContactSection';
import Link from 'next/link';
import style from './style.module.scss';

export const KycCardOpenReview = () => {
  return (
    <KycCardLayout headerTitle={t('Review in progress')} HeaderIcon={<ClockIcon />} className={style['kyc-custom']}>
      <div className={style['kyc-open-review']}>
        <div className={style['kyc-open-review__left-side']}>
          <h6 className={style['kyc-open-review__left-side__title']}>{t('Complete your compliance review')}</h6>
          <p className={style['kyc-open-review__left-side__description']}>
            {t(
              'You have an open compliance review. Please complete all required steps and submit your review for approval.'
            )}
          </p>
          <Link href='/user/tiers'>
            <a className={style['kyc-open-review__cta']}>{t('Go to Tiers')}</a>
          </Link>
        </div>
        <KycCardContactUsSection />
      </div>
    </KycCardLayout>
  );
};
